// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stop-scrolling {
  height: 100%;
  overflow: hidden;
}

.NavBar__Animation {
  position: sticky;
  top: 0;
  z-index: 10000;
  height: 10.755dvh;
}

.NavBar_White {
  background-color: white;
}

.NavBar_Black {
  background-color: black;
}

.navbar__Grid {
  grid-column: 3 / 5;
  display: flex;
  justify-content: space-between;
  min-width: 314px;
  color: white;
}

.navbar__Grid__item {
  font-size: 18px;
  font-weight: bold;
  opacity: 40%;
}

.active {
  opacity: 95% !important;
}

.navbar__Grid__item__Language {
  font-size: 18px;
  font-weight: bold;
  opacity: 50%;
  color: white;
  position: absolute;
  right: -4em;
  top: 2.65em;
  cursor: pointer;
  text-align: left;
}

.navbar__Grid__item__Language p {
  line-height: 16px;
}

.navbar__Grid__Mobile {
  display: none;
}

.navbar-container__test__Logo {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  padding-top: 2.5em;
  align-content: center;
  align-items: end;
  position: sticky;
  top: 0;
  z-index: 2;
}

.navbar__Grid__Logo {
  grid-column: 1 / 2;
  display: flex;
  justify-content: space-between;
  width: clamp(150px, 100%, 100%);
}

.HomeLogo {
  height: 27px;
}

@media all and (min-width: 1921px) {
}

@media all and (min-width: 1441px) and (max-width: 1920px) {
}

@media all and (min-width: 1025px) and (max-width: 1440px) {
  .grid-container__footer__mobile {
    display: none !important;
  }
}

@media all and (min-width: 769px) and (max-width: 1024px) {
  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    left: 0;
    top: 2em;
    align-items: center;
    z-index: 2;
  }

  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar__Grid__item__Language__mobile {
    font-size: 24px;
    font-weight: bold;
    opacity: 50%;
    color: white;
    cursor: pointer;
    text-align: left;
  }

  .navbar__Grid__Logo {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid__Mobile {
    grid-column: 2 / 3;
    display: flex;
    justify-content: end;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid {
    display: none !important;
  }

  .navbar__Grid__Mobile {
    display: flex !important;
    z-index: 200 !important;
  }

  .menuOpen {
    position: relative;
    top: 0;
    left: 0;
    z-index: 205;
  }

  .menu__mobile__left .menu__mobile__Mainfooter_links {
    padding-bottom: 1.95em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter_links {
    padding-bottom: 2em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    gap: 1em;
  }

  .menu__mobile__left .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    padding-right: 0.5em;
  }

  .menu__mobile__Mainfooter__logos img {
    max-width: 100%;
  }

  .menu__Mobile__Grid {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 200;
  }

  .menu__Mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    height: 85.25dvh;
    position: relative;
    top: 10dvh;
    left: 0;
    z-index: 3;
  }

  .navbar-container__mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    position: relative;
    top: 2em;
    left: 0;
    z-index: 3;
  }

  .hamburger__Mobile {
    align-self: center;
    justify-self: right;
  }

  .menu__mobile__right h1 {
    font-size: 24px;
    font-weight: bold;
  }

  .menu__mobile__right p {
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__nav {
    display: grid;
    gap: 3em;
    justify-items: right;
    align-self: self-start;
    padding-bottom: 0.5em;
  }

  .menu__mobile__footer_links {
    display: grid;
    gap: 0.5em;
    justify-items: left;
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__left .menu__mobile__footer_links {
    padding-bottom: 2em;
  }

  .menu__mobile__right .menu__mobile__footer_links {
    padding-bottom: 2em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    gap: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  .menu__mobile__left .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
  }

  .menu__mobile__right {
    display: grid;
  }

  .menu__mobile__left {
    display: grid;
  }
}

@media all and (min-width: 426px) and (max-width: 768px) {
  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    left: 0;
    top: 2em;
    align-items: center;
    z-index: 2;
  }

  .navbar__Grid__item__Language__mobile {
    font-size: 24px;
    font-weight: bold;
    opacity: 50%;
    color: white;
    cursor: pointer;
    text-align: left;
  }

  .navbar__Grid__Logo {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid__Mobile {
    grid-column: 2 / 3;
    display: flex;
    justify-content: end;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid {
    display: none !important;
  }

  .navbar__Grid__Mobile {
    display: flex !important;
    z-index: 200 !important;
  }

  .menuOpen {
    position: relative;
    top: 0;
    left: 0;
    z-index: 205;
  }

  .menu__mobile__left .menu__mobile__Mainfooter_links {
    padding-bottom: 1.95em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter_links {
    padding-bottom: 2em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    gap: 1em;
  }

  .menu__mobile__left .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    padding-right: 0.5em;
  }

  .menu__mobile__Mainfooter__logos img {
    max-width: 100%;
  }

  .menu__Mobile__Grid {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100vw;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,

      rgba(0, 0, 0, 0.6) 50%,

      rgba(0, 0, 0, 1) 100%
    );
    z-index: 200;
  }

  .menu__Mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    height: 85.25dvh;
    position: relative;
    top: 10dvh;
    left: 0;
    z-index: 3;
  }

  .navbar-container__mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    position: relative;
    top: 2em;
    left: 0;
    z-index: 3;
  }

  .hamburger__Mobile {
    align-self: center;
    justify-self: right;
  }

  .menu__mobile__right h1 {
    font-size: 24px;
    font-weight: bold;
  }

  .menu__mobile__right p {
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__nav {
    display: grid;
    gap: 3em;
    justify-items: right;
    align-self: self-start;
    padding-bottom: 0.5em;
  }

  .menu__mobile__footer_links {
    display: grid;
    gap: 0.5em;
    justify-items: left;
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__left .menu__mobile__footer_links {
    padding-bottom: 2em;
  }

  .menu__mobile__right .menu__mobile__footer_links {
    padding-bottom: 2em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    gap: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  .menu__mobile__left .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
  }

  .menu__mobile__right {
    display: grid;
  }

  .menu__mobile__left {
    display: grid;
  }
}

@media all and (min-width: 376px) and (max-width: 425px) {
  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    left: 0;
    top: 2em;
    align-items: center;
    z-index: 2;
  }

  .navbar__Grid__item__Language__mobile {
    font-size: 24px;
    font-weight: bold;
    opacity: 50%;
    color: white;
    cursor: pointer;
    text-align: left;
  }

  .navbar__Grid__Logo {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid__Mobile {
    grid-column: 2 / 3;
    display: flex;
    justify-content: end;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid {
    display: none !important;
  }

  .navbar__Grid__Mobile {
    display: flex !important;
    z-index: 200 !important;
  }

  .menuOpen {
    position: relative;
    top: 0;
    left: 0;
    z-index: 205;
  }

  .menu__mobile__left .menu__mobile__Mainfooter_links {
    padding-bottom: 1.95em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter_links {
    padding-bottom: 2em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    gap: 1em;
  }

  .menu__mobile__left .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    padding-right: 0.5em;
  }

  .menu__mobile__Mainfooter__logos img {
    max-width: 100%;
  }

  .menu__Mobile__Grid {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 200;
  }

  .menu__Mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    height: 85.25dvh;
    position: relative;
    top: 10dvh;
    left: 0;
    z-index: 3;
  }

  .navbar-container__mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    position: relative;
    top: 2em;
    left: 0;
    z-index: 3;
  }

  .hamburger__Mobile {
    align-self: center;
    justify-self: right;
  }

  .menu__mobile__right h1 {
    font-size: 24px;
    font-weight: bold;
  }

  .menu__mobile__right p {
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__nav {
    display: grid;
    gap: 3em;
    justify-items: right;
    align-self: self-start;
    padding-bottom: 0.5em;
  }

  .menu__mobile__footer_links {
    display: grid;
    gap: 0.5em;
    justify-items: left;
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__left .menu__mobile__footer_links {
    padding-bottom: 2em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer_links {
    padding-bottom: 2em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    gap: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  .menu__mobile__left .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
  }

  .menu__mobile__right {
    display: grid;
  }

  .menu__mobile__left {
    display: grid;
  }
}

@media all and (min-width: 321px) and (max-width: 375px) {
  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    left: 0;
    top: 2em;
    align-items: center;
    z-index: 2;
  }

  .navbar__Grid__item__Language__mobile {
    font-size: 24px;
    font-weight: bold;
    opacity: 50%;
    color: white;
    cursor: pointer;
    text-align: left;
  }

  .navbar__Grid__Logo {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid__Mobile {
    grid-column: 2 / 3;
    display: flex;
    justify-content: end;
    width: clamp(150px, 100%, 100%);
  }

  .navbar__Grid {
    display: none !important;
  }

  .navbar__Grid__Mobile {
    display: flex !important;
    z-index: 200 !important;
  }

  .menuOpen {
    position: relative;
    top: 0;
    left: 0;
    z-index: 205;
  }

  .menu__mobile__left .menu__mobile__Mainfooter_links {
    padding-bottom: 1.95em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter_links {
    padding-bottom: 2em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    gap: 1em;
  }

  .menu__mobile__left .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    padding-right: 0.5em;
  }

  .menu__mobile__Mainfooter__logos img {
    max-width: 100%;
  }

  .menu__Mobile__Grid {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 200;
  }

  .menu__Mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    height: 85.25dvh;
    position: relative;
    top: 10dvh;
    left: 0;
    z-index: 3;
  }

  .navbar-container__mobile {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    position: relative;
    top: 2em;
    left: 0;
    z-index: 3;
  }

  .hamburger__Mobile {
    align-self: center;
    justify-self: right;
  }

  .menu__mobile__right h1 {
    font-size: 24px;
    font-weight: bold;
  }

  .menu__mobile__right p {
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__nav {
    display: grid;
    gap: 3em;
    justify-items: right;
    align-self: self-start;
    padding-bottom: 0.5em;
  }

  .menu__mobile__footer_links {
    display: grid;
    gap: 0.5em;
    justify-items: left;
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__left .menu__mobile__footer_links {
    padding-bottom: 2em;
  }

  .menu__mobile__right .menu__mobile__footer_links {
    padding-bottom: 2em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    gap: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  .menu__mobile__left .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
  }

  .menu__mobile__right {
    display: grid;
  }

  .menu__mobile__left {
    display: grid;
  }
}

@media all and (max-width: 320px) {
  .navbar__Grid__item__Language {
    display: none;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    left: 0;
    top: 2em;
    align-items: center;
    z-index: 2;
  }

  .navbar__Grid__item__Language__mobile {
    font-size: 24px;
    font-weight: bold;
    opacity: 50%;
    color: white;
    cursor: pointer;
    text-align: left;
  }

  .navbar__Grid__Logo {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .navbar__Grid__Mobile {
    grid-column: 2 / 3;
    display: flex;
    justify-content: end;
    width: 100%;
  }

  .navbar__Grid {
    display: none !important;
  }

  .navbar__Grid__Mobile {
    display: flex !important;
    z-index: 200 !important;
  }

  .menuOpen {
    position: relative;
    top: 0;
    left: 0;
    z-index: 205;
  }

  .menu__mobile__left .menu__mobile__Mainfooter_links {
    padding-bottom: 1.95em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter_links {
    padding-bottom: 2em;
    line-height: 20px!important;
    font-size: 12px!important;
    gap: 0.5em;
  }

  .menu__mobile__right .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    gap: 1em;
  }

  .menu__mobile__left .menu__mobile__Mainfooter__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    justify-items: start;
    padding-right: 0.5em;
  }

  .menu__mobile__Mainfooter__logos img {
    max-width: 100%;
  }

  .menu__Mobile__Grid {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100vw;
    background-color: black;
    z-index: 200;
  }

  .menu__Mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    height: 85.25dvh;
    position: relative;
    top: 10dvh;
    left: 0;
    z-index: 3;
  }

  .navbar-container__mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    width: 89.5%;
    color: white;
    position: relative;
    top: 2em;
    left: 0;
    z-index: 3;
  }

  .hamburger__Mobile {
    align-self: center;
    justify-self: right;
  }

  .menu__mobile__right h1 {
    font-size: 24px;
    font-weight: bold;
  }

  .menu__mobile__right p {
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__nav {
    display: grid;
    gap: 3em;
    justify-items: right;
    align-self: self-start;
    padding-bottom: 0.5em;
  }

  .menu__mobile__footer_links {
    display: grid;
    gap: 0.5em;
    justify-items: left;
    font-size: 12px;
    font-weight: normal;
    opacity: 60%;
  }

  .menu__mobile__left .menu__mobile__footer_links {
    padding-bottom: 3em;
  }

  .menu__mobile__right .menu__mobile__footer_links {
    padding-bottom: 3em;
    line-height: 20px;
  }

  .menu__mobile__right .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
    gap: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }

  .menu__mobile__left .menu__mobile__footer__logos {
    display: grid;
    grid-auto-flow: column;
    align-items: end;
  }

  .menu__mobile__right {
    display: grid;
  }

  .menu__mobile__left {
    display: grid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/NavBar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IAEd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IAEd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ;;;;;;;KAOC;IACD,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IAEd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IAEd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IAEd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".stop-scrolling {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.NavBar__Animation {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10000;\r\n  height: 10.755dvh;\r\n}\r\n\r\n.NavBar_White {\r\n  background-color: white;\r\n}\r\n\r\n.NavBar_Black {\r\n  background-color: black;\r\n}\r\n\r\n.navbar__Grid {\r\n  grid-column: 3 / 5;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  min-width: 314px;\r\n  color: white;\r\n}\r\n\r\n.navbar__Grid__item {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 40%;\r\n}\r\n\r\n.active {\r\n  opacity: 95% !important;\r\n}\r\n\r\n.navbar__Grid__item__Language {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 50%;\r\n  color: white;\r\n  position: absolute;\r\n  right: -4em;\r\n  top: 2.65em;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.navbar__Grid__item__Language p {\r\n  line-height: 16px;\r\n}\r\n\r\n.navbar__Grid__Mobile {\r\n  display: none;\r\n}\r\n\r\n.navbar-container__test__Logo {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  padding-top: 2.5em;\r\n  align-content: center;\r\n  align-items: end;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.navbar__Grid__Logo {\r\n  grid-column: 1 / 2;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: clamp(150px, 100%, 100%);\r\n}\r\n\r\n.HomeLogo {\r\n  height: 27px;\r\n}\r\n\r\n@media all and (min-width: 1921px) {\r\n}\r\n\r\n@media all and (min-width: 1441px) and (max-width: 1920px) {\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  .grid-container__footer__mobile {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 2em;\r\n    align-items: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar__Grid__item__Language__mobile {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    opacity: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar__Grid__Logo {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: end;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    display: flex !important;\r\n    z-index: 200 !important;\r\n  }\r\n\r\n  .menuOpen {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 205;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 1.95em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    gap: 1em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    padding-right: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__Mainfooter__logos img {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .menu__Mobile__Grid {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100dvh;\r\n    width: 100vw;\r\n    background-color: rgba(0, 0, 0, 0.9);\r\n    z-index: 200;\r\n  }\r\n\r\n  .menu__Mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    height: 85.25dvh;\r\n    position: relative;\r\n    top: 10dvh;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .navbar-container__mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    top: 2em;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .hamburger__Mobile {\r\n    align-self: center;\r\n    justify-self: right;\r\n  }\r\n\r\n  .menu__mobile__right h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .menu__mobile__right p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__nav {\r\n    display: grid;\r\n    gap: 3em;\r\n    justify-items: right;\r\n    align-self: self-start;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__footer_links {\r\n    display: grid;\r\n    gap: 0.5em;\r\n    justify-items: left;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    gap: 1em;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__left {\r\n    display: grid;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 2em;\r\n    align-items: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .navbar__Grid__item__Language__mobile {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    opacity: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar__Grid__Logo {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: end;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    display: flex !important;\r\n    z-index: 200 !important;\r\n  }\r\n\r\n  .menuOpen {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 205;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 1.95em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    gap: 1em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    padding-right: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__Mainfooter__logos img {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .menu__Mobile__Grid {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100dvh;\r\n    width: 100vw;\r\n    background-image: linear-gradient(\r\n      to bottom,\r\n      rgba(0, 0, 0, 1) 0%,\r\n\r\n      rgba(0, 0, 0, 0.6) 50%,\r\n\r\n      rgba(0, 0, 0, 1) 100%\r\n    );\r\n    z-index: 200;\r\n  }\r\n\r\n  .menu__Mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    height: 85.25dvh;\r\n    position: relative;\r\n    top: 10dvh;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .navbar-container__mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    top: 2em;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .hamburger__Mobile {\r\n    align-self: center;\r\n    justify-self: right;\r\n  }\r\n\r\n  .menu__mobile__right h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .menu__mobile__right p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__nav {\r\n    display: grid;\r\n    gap: 3em;\r\n    justify-items: right;\r\n    align-self: self-start;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__footer_links {\r\n    display: grid;\r\n    gap: 0.5em;\r\n    justify-items: left;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    gap: 1em;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__left {\r\n    display: grid;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 2em;\r\n    align-items: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .navbar__Grid__item__Language__mobile {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    opacity: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar__Grid__Logo {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: end;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    display: flex !important;\r\n    z-index: 200 !important;\r\n  }\r\n\r\n  .menuOpen {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 205;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 1.95em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    gap: 1em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    padding-right: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__Mainfooter__logos img {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .menu__Mobile__Grid {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100dvh;\r\n    width: 100vw;\r\n    background-color: rgba(0, 0, 0, 0.9);\r\n    z-index: 200;\r\n  }\r\n\r\n  .menu__Mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    height: 85.25dvh;\r\n    position: relative;\r\n    top: 10dvh;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .navbar-container__mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    top: 2em;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .hamburger__Mobile {\r\n    align-self: center;\r\n    justify-self: right;\r\n  }\r\n\r\n  .menu__mobile__right h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .menu__mobile__right p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__nav {\r\n    display: grid;\r\n    gap: 3em;\r\n    justify-items: right;\r\n    align-self: self-start;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__footer_links {\r\n    display: grid;\r\n    gap: 0.5em;\r\n    justify-items: left;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    gap: 1em;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__left {\r\n    display: grid;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 2em;\r\n    align-items: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .navbar__Grid__item__Language__mobile {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    opacity: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar__Grid__Logo {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: end;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .navbar__Grid {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    display: flex !important;\r\n    z-index: 200 !important;\r\n  }\r\n\r\n  .menuOpen {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 205;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 1.95em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    gap: 1em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    padding-right: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__Mainfooter__logos img {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .menu__Mobile__Grid {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100dvh;\r\n    width: 100vw;\r\n    background-color: rgba(0, 0, 0, 0.9);\r\n    z-index: 200;\r\n  }\r\n\r\n  .menu__Mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    height: 85.25dvh;\r\n    position: relative;\r\n    top: 10dvh;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .navbar-container__mobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    top: 2em;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .hamburger__Mobile {\r\n    align-self: center;\r\n    justify-self: right;\r\n  }\r\n\r\n  .menu__mobile__right h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .menu__mobile__right p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__nav {\r\n    display: grid;\r\n    gap: 3em;\r\n    justify-items: right;\r\n    align-self: self-start;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__footer_links {\r\n    display: grid;\r\n    gap: 0.5em;\r\n    justify-items: left;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    gap: 1em;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__left {\r\n    display: grid;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 320px) {\r\n  .navbar__Grid__item__Language {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    left: 0;\r\n    top: 2em;\r\n    align-items: center;\r\n    z-index: 2;\r\n  }\r\n\r\n  .navbar__Grid__item__Language__mobile {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    opacity: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    text-align: left;\r\n  }\r\n\r\n  .navbar__Grid__Logo {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: end;\r\n    width: 100%;\r\n  }\r\n\r\n  .navbar__Grid {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar__Grid__Mobile {\r\n    display: flex !important;\r\n    z-index: 200 !important;\r\n  }\r\n\r\n  .menuOpen {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 205;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 1.95em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter_links {\r\n    padding-bottom: 2em;\r\n    line-height: 20px!important;\r\n    font-size: 12px!important;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    gap: 1em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__Mainfooter__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    justify-items: start;\r\n    padding-right: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__Mainfooter__logos img {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .menu__Mobile__Grid {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100dvh;\r\n    width: 100vw;\r\n    background-color: black;\r\n    z-index: 200;\r\n  }\r\n\r\n  .menu__Mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    height: 85.25dvh;\r\n    position: relative;\r\n    top: 10dvh;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .navbar-container__mobile {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    top: 2em;\r\n    left: 0;\r\n    z-index: 3;\r\n  }\r\n\r\n  .hamburger__Mobile {\r\n    align-self: center;\r\n    justify-self: right;\r\n  }\r\n\r\n  .menu__mobile__right h1 {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .menu__mobile__right p {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__nav {\r\n    display: grid;\r\n    gap: 3em;\r\n    justify-items: right;\r\n    align-self: self-start;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__footer_links {\r\n    display: grid;\r\n    gap: 0.5em;\r\n    justify-items: left;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer_links {\r\n    padding-bottom: 3em;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer_links {\r\n    padding-bottom: 3em;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .menu__mobile__right .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n    gap: 1em;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 0.5em;\r\n  }\r\n\r\n  .menu__mobile__left .menu__mobile__footer__logos {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    align-items: end;\r\n  }\r\n\r\n  .menu__mobile__right {\r\n    display: grid;\r\n  }\r\n\r\n  .menu__mobile__left {\r\n    display: grid;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
